import {
    Button,
    Card,
    Col,
    Form,
    Input,
    Row,
    Spin,
    message,
    App,
    Select,
} from "antd";
import { LeftOutlined, LoadingOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { EDIT_EMAIL, LIST_COURSE, VIEW_EMAIL } from "../../apis/apis";
import { useNavigate, useParams } from "react-router-dom";

import CulsightPageLoader from "../../components/CulsightPageLoader";
import HtmlEditorWithPreview from "../../components/HtmlEditorWithPreview";

export default function EditEmail() {
    const { id } = useParams();
    const { notification } = App.useApp();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [form] = Form.useForm();
    const [name, set_name] = useState("")
    const [envelope_sender, set_envelope_sender] = useState("")
    const [subject, set_subject] = useState("")
    const [course_id, set_course_id] = useState("");
    const [course_List, set_course_List] = useState([]);
    const [message_value, set_message_value] = useState("");
    const [html_type, set_html_type] = useState(null)
    const [errors, set_errors] = useState("");
    const [templates_images, set_templates_images] = useState("");
    const [image_file, set_image_file] = useState(null);
    const [existing_attachment, set_existing_attachment] = useState(null);

    useEffect(() => {
        const VIEW_API = async () => {
            const FORM_DATA = new FormData();
            FORM_DATA.append("id", atob(id));
            const EDIT_API_RESPONSE = await VIEW_EMAIL(FORM_DATA);
            if (EDIT_API_RESPONSE?.data?.status) {
                const response_data = EDIT_API_RESPONSE?.data?.data;
                set_name(response_data?.name);
                set_course_id(response_data?.course_id)
                set_envelope_sender(response_data?.envelope_sender);
                set_subject(response_data?.subject);
                set_message_value(response_data?.message_value);
                set_html_type(response_data?.html_type === true ? 1 : 0);
                set_templates_images(response_data?.templates_images);
                set_existing_attachment(response_data?.attachment || null);
                setLoading(false);

            }
        };

        VIEW_API();
    }, [id]);


    const onFinish = async () => {
        setLoading(true);
        const FORM_DATA = new FormData();
        FORM_DATA.append("id", atob(id));
        FORM_DATA.append("name", name);
        FORM_DATA.append("envelope_sender", envelope_sender);
        FORM_DATA.append("subject", subject);
        FORM_DATA.append("course_id", course_id);
        FORM_DATA.append("message_value", message_value);
        FORM_DATA.append("html_type", html_type);
        FORM_DATA.append("templates_images", templates_images);
  if (image_file) {
    FORM_DATA.append("attachment", image_file);           // binary
} else if (existing_attachment?.path) {
    FORM_DATA.append("attachment", existing_attachment.path);  // url string
}
        try {
            const response = await EDIT_EMAIL(FORM_DATA);

            if (response?.data?.status) {
                notification.success({
                    message: "Successful",
                    description: response?.data?.message,
                });
                navigate("/email-template");
            } else {
                setLoading(false);
                set_errors(response?.data?.errors);
            }
        } catch (error) {
            message.error(
                "Server Error: " + (error?.response?.data?.message || "Unknown error")
            );
        }
    };

    const extractNameOnly = (value) => {
        return value.replace(/[<>@.]/g, "");
    };

    const COURSE_LIST_API = async () => {
        const API_CALL = await LIST_COURSE(new FormData());
        if (API_CALL?.data?.status) {
            set_course_List(API_CALL.data.data.map(item => ({
                label: item.title,
                value: item.id
            })));
        }
    };
    useEffect(() => {
        COURSE_LIST_API();
    }, []);

    const handleSearchCourse = async (searchText) => {

        try {
            const formData = new FormData();
            formData.append("title", searchText);
            const response = await LIST_COURSE(formData);
            if (response?.data?.status) {
                const options = response.data.data.map((item) => ({
                    label: item.title,
                    value: item.id,
                }));
                set_course_List(options);
            } else {
                set_course_List([]);
            }
        } catch (error) {
            console.error("Error searching Course list:", error);
            set_course_List([]);
        } finally {

        }
    };

    return (
        <div className="lms-body">
            <Card>
                <div className="lms-form">


                    <Row>
                        <Col span={12}>
                            <h2><span style={{ cursor: "pointer", marginRight: "5px" }}
                                onClick={() => navigate("/email-template")}><LeftOutlined /></span>Edit Email Template</h2>
                        </Col>
                    </Row>

                    {loading ? (
                        <>
                            <CulsightPageLoader />
                        </>
                    ) : (
                        <>




                            <Form
                                form={form}
                                layout="vertical"
                                autoComplete="off"
                                onFinish={onFinish}
                                validateTrigger="onSubmit"
                            >


                                <Form.Item
                                    label="Name"
                                    validateTrigger="onChange"
                                    rules={[
                                        { min: 2, message: "Name must be at least 2 characters" },
                                        { max: 50, message: "Name cannot exceed 50 characters" },
                                        {
                                            pattern: /^[A-Za-z-0-9_. ]+$/,
                                            message: "Special characters are not allowed",
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder="Enter name"
                                        value={name}
                                        showCount
                                        onChange={(e) => set_name(e.target.value)}
                                    />
                                    {errors?.name ? (
                                        <>
                                            <span style={{ color: "red" }}>{errors?.name}</span>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                </Form.Item>


                                <Form.Item label="Envelope Sender">
                                    <Input
                                        value={envelope_sender}
                                        placeholder="Enter envelope sender"
                                        onChange={(e) => set_envelope_sender(extractNameOnly(e.target.value))}
                                    />
                                    {errors?.envelope_sender ? (
                                        <>
                                            <span style={{ color: "red" }}>{errors?.envelope_sender}</span>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                </Form.Item>

                                <Form.Item label="Subject">
                                    <Input
                                        placeholder="Enter subject"
                                        onChange={(e) => set_subject(e.target.value)}
                                        value={subject}
                                    />
                                    {errors?.subject ? (
                                        <>
                                            <span style={{ color: "red" }}>{errors?.subject}</span>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                </Form.Item>
                                <Form.Item label="Images (Comma separated urls)">
                                    <Input
                                        placeholder="Images"
                                        value={templates_images}
                                        onChange={(e) => set_templates_images(e.target.value)}
                                    />
                                    {errors?.subject && (
                                        <span style={{ color: "red" }}>{errors?.subject}</span>
                                    )}
                                </Form.Item>

                                <Form.Item label="Attachments (PDF, DOC, XLS, ZIP, PNG, JPG · ≤8MB · downloads are tracked)">
    <Input
        type="file"
        accept=".pdf,.doc,.docx,.xls,.xlsx,.zip,.png,.jpg,.jpeg"
        onChange={(e) => set_image_file(e.target.files[0])}
    />
    {existing_attachment && !image_file && (
        <div style={{ marginTop: 6, padding: "6px 10px", background: "#f5f5f5", borderRadius: 6, display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: 12, color: "#555" }}>Current file:</span>
            <span style={{ fontSize: 13, fontWeight: 500, color: "#1677ff" }}>
                {existing_attachment.filename}
            </span>
            <span style={{ fontSize: 11, color: "#999" }}>
                ({(existing_attachment.size / 1024).toFixed(1)} KB)
            </span>
        </div>
    )}
    {errors?.attachment && (
        <span style={{ color: "red" }}>{errors?.attachment}</span>
    )}
</Form.Item>
                                {course_List.length > 0 && <>


                                    <Form.Item label="Select Course">
                                        <Select
                                            showSearch
                                            size="large"
                                            placeholder="Select Course"
                                            value={course_id}
                                            onChange={(value) => set_course_id(value)}
                                            onSearch={handleSearchCourse}
                                            filterOption={false}
                                            notFoundContent={loading ? <Spin size="small" /> : null}
                                            options={course_List}
                                        />
                                    </Form.Item>
                                </>}


                                {/* <Form.Item label="HTMl Type">
                                    <Radio.Group
                                        onChange={(e) => set_html_type(e.target.value)}
                                        value={html_type}
                                    >
                                        <Radio value={1}>HTML</Radio>
                                        <Radio value={0}>Text</Radio>
                                    </Radio.Group>
                                </Form.Item> */}

                                <HtmlEditorWithPreview setHtmlCode={set_message_value} description='Message' htmlCode={message_value} />
                                {/* <Form.Item label="Message">
                                    <Input.TextArea
                                    value={message_value}
                                        rows={6}
                                        placeholder="Enter message_value"
                                        onChange={(e) => set_message_value(e.target.value)}
                                    />
                                    {errors?.message_value ? (
                                        <>
                                            <span style={{ color: "red" }}>{errors?.message_value}</span>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                </Form.Item>
 */}

                                <Form.Item>
                                    {loading ? (
                                        <>
                                            <Button type="primary" style={{ float: "right" }}>
                                                Save{" "}
                                                <Spin
                                                    indicator={<LoadingOutlined spin />}
                                                    size="small"
                                                />
                                            </Button>
                                        </>
                                    ) : (
                                        <>
                                            <Button
                                                type="primary"
                                                style={{ float: "right" }}
                                                htmlType="submit"
                                            >
                                                Save
                                            </Button>
                                        </>
                                    )}
                                </Form.Item>

                            </Form>
                        </>
                    )}
                </div>
            </Card>
        </div>
    );
}
